export default {
  REGISTRATION_DISABLED: "no_reg",
  PAYMENTS: "payments",
  RECORDING: "recording",
};
